import React, { useContext } from 'react';
import * as PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';

import { t } from '../../../../../../utils/i18next';
import { paymentTypes } from '../../../../../../constants/mixpanel';
import PaymentButtonWrapper from '../../../../general/PaymentButtonWrapper';
import { storeContext } from '../../../../../context';
import PaymentPlanButtonOptions from '../PaymentPlanButtonOptions';
import PaymentItem from './PaymentItem';

const translationBase = 'payables.total_side_bar.payment';

/**
 * A components which may present a PaymentButtonRedirect or a PaymentPlanButtonOptions
 * @param {Number} type - PaymentItem.paymentTypes enum
 * @param {String} buttonColor - Material-UI button color
 */
const PaymentItemButton = observer(props => {
  const {
    payable: { standingAmount, hasActivePaymentPlan, appointmentsTotalBalance },
    translations: { currentLanguage }
  } = useContext(storeContext);

  const { MAKE_A_PAYMENT, VIEW_PAYMENT_PLAN_OPTIONS, PAYMENT_PLAN } =
    PaymentItem.paymentTypes;

  const { PAYMENT, ASSIST_PP } = paymentTypes;

  const { type, buttonColor } = props;

  const disablePaymentButton =
    standingAmount + appointmentsTotalBalance <= 0 ||
    (type === PAYMENT_PLAN && !hasActivePaymentPlan);

  const getButtonType = () => {
    switch (type) {
      case MAKE_A_PAYMENT:
        return PAYMENT;
      case VIEW_PAYMENT_PLAN_OPTIONS:
        return ASSIST_PP;
      case PAYMENT_PLAN:
        return ASSIST_PP;
    }
  };

  const getButtonText = () => {
    switch (type) {
      case MAKE_A_PAYMENT:
        return `${translationBase}.payment_button`;
      case VIEW_PAYMENT_PLAN_OPTIONS:
        return 'payables.total_side_bar.assist.pp_options';
      case PAYMENT_PLAN:
        return `payables.payment_options.see_payment_options`;
    }
  };

  return (
    <>
      {type !== PAYMENT_PLAN || disablePaymentButton ? (
        <PaymentButtonWrapper
          variant="contained"
          color={buttonColor}
          size="large"
          aria-label={t(getButtonText())}
          paymentButtonType={getButtonType()}
          disabled={disablePaymentButton}
        >
          {t(getButtonText())}
        </PaymentButtonWrapper>
      ) : (
        <PaymentPlanButtonOptions
          buttonColor={buttonColor}
          buttonText={t(getButtonText())}
        />
      )}
    </>
  );
});

PaymentItemButton.propTypes = {
  type: PropTypes.number,
  buttonColor: PropTypes.string
};

export default PaymentItemButton;
